import type { DocumentType } from '@/types'

export const MAX_FILE_SIZE = 10 * 1024 * 1024

export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]

export const DOCUMENT_TYPE_OPTIONS: DocumentType[] = [
  'ID_CARD',
  'HEALTH_INSURANCE',
  'TELK_DECISION',
  'EPICRISIS',
  'MEDICAL_REFERRAL',
  'LAB_RESULT',
  'PRESCRIPTION',
  'HOSPITALIZATION',
  'CONTRACT',
  'DIPLOMA',
  'CERTIFICATE',
  'QUALIFICATION',
  'ACSU_REPORT',
  'LICENSE',
  'DOSIE',
  'DOPALNITELEN_LIST',
  'SASTOYANIE',
  'TERAPIA',
  'LICHNO_DELO',
  'SADARZHANIE_LICHNO_DELO',
  'ZAYAVLENIE',
  'DEKLARACIA_LICHNI_DANNI',
  'PRAVILNIK',
  'ANKETEN_LIST',
  'SEMEINI_FAKTORI',
  'IPP',
  'IOPP',
  'ANEKS_NOV_SROK',
  'ANEKS_TAKSI',
  'FINALNI_REZULTATI_IPP',
  'OTHER',
]

export type DocumentTypeValue = DocumentType

export const DEFAULT_DOCUMENT_TYPE: DocumentTypeValue = 'OTHER'

export interface FileItem {
  file: File
  documentType: DocumentTypeValue
  description: string
  documentDate: string
}
